var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9998 4.66675V4.66675C14.3093 4.66675 14.4641 4.66675 14.5949 4.67056C19.3602 4.80921 23.1907 8.63971 23.3294 13.405C23.3332 13.5358 23.3332 13.6906 23.3332 14.0001V19.9395C23.3332 21.2431 23.3332 21.8949 23.0409 22.3743C22.875 22.6466 22.6464 22.8752 22.3741 23.0412C21.8947 23.3334 21.2429 23.3334 19.9392 23.3334H13.9998C13.6903 23.3334 13.5356 23.3334 13.4047 23.3296C8.63946 23.191 4.80897 19.3605 4.67031 14.5952C4.6665 14.4643 4.6665 14.3096 4.6665 14.0001V14.0001",
    stroke: "#666666",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 12.8333L17.5 12.8333",
    stroke: "#666666",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8335 9.33325L5.8335 2.33325",
    stroke: "#666666",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3335 5.83325L9.3335 5.83325",
    stroke: "#666666",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 17.5H17.5",
    stroke: "#666666",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForChat);
export default __webpack_public_path__ + "static/media/for_chat.ea6176d98a7fcf8c19c9f0ad6806f5a3.svg";
export { ForwardRef as ReactComponent };